import { render } from "./InputHeader.vue?vue&type=template&id=701766e0&scoped=true"
import script from "./InputHeader.vue?vue&type=script&lang=js"
export * from "./InputHeader.vue?vue&type=script&lang=js"

import "./InputHeader.vue?vue&type=style&index=0&id=701766e0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701766e0"]])

export default __exports__